import { useAppContext } from '../Services/AppContext';

const useTranslation = () => {
	const { translation } = useAppContext();

	function replaceAllString(
		str: string,
		find: string,
		replace: string,
	): string {
		const regex = new RegExp(find.replace(/[.*+?^${}()|[\]\\]/g, '\\$&'), 'g');
		return str.replace(regex, replace);
	}

	function replaceParameters(
		trans: string,
		params: { [key: string]: string },
	): string {
		for (const paramKey in params) {
			if (Object.prototype.hasOwnProperty.call(params, paramKey)) {
				trans = replaceAllString(trans, `%${paramKey}%`, params[paramKey]);
			}
		}
		return trans;
	}

	const handleTranslate = (
		key: string,
		params?: Record<string, string | number>,
	) => {
		let trans = translation[key] ?? key;

		if (params) {
			trans = replaceParameters(trans, params);
		}

		return trans;
	};

	return {
		t: handleTranslate,
	};
};

export default useTranslation;
